import { ItemsGrid } from '@rdrive/plugin-items-grid';
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import setup from './setup.js';

export default {
  name: 'teams-page-overview',
  components: { ItemsGrid, StackedHorizontalBarChart },
  setup,
};
